export default __webpack_public_path__ + "static/media/vis-shape.459c1c2c.svg";